/**
 * Servicio para gestionar inventario (availability y restrictions)
 * Incluye operaciones CRUD y bulk operations para disponibilidad y restricciones
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { apiService } from '@/utils/api';
export var RESTRICTION_TYPES = [
    { value: 'CLOSED', label: 'Closed' },
    { value: 'MIN_STAY', label: 'Minimum Stay' },
    { value: 'MAX_STAY', label: 'Maximum Stay' },
    { value: 'CLOSED_TO_ARRIVAL', label: 'Closed to Arrival' },
    { value: 'CLOSED_TO_DEPARTURE', label: 'Closed to Departure' },
    { value: 'NO_CHECK_IN', label: 'No Check-in' },
    { value: 'NO_CHECK_OUT', label: 'No Check-out' },
];
var InventoryService = /** @class */ (function () {
    function InventoryService() {
    }
    // === ROOM TYPES ===
    InventoryService.prototype.getRoomTypes = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParams, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParams = new URLSearchParams();
                        if (params === null || params === void 0 ? void 0 : params.property)
                            queryParams.append('property', params.property.toString());
                        if (params === null || params === void 0 ? void 0 : params.search)
                            queryParams.append('search', params.search);
                        if (params === null || params === void 0 ? void 0 : params.page)
                            queryParams.append('page', params.page.toString());
                        if (params === null || params === void 0 ? void 0 : params.limit)
                            queryParams.append('page_size', params.limit.toString());
                        return [4 /*yield*/, apiService.get("/api/v1/channel_manager/room_types/?".concat(queryParams))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    // === RATE PLANS ===
    InventoryService.prototype.getRatePlans = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParams, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParams = new URLSearchParams();
                        if (params === null || params === void 0 ? void 0 : params.property)
                            queryParams.append('property', params.property.toString());
                        if (params === null || params === void 0 ? void 0 : params.room_type)
                            queryParams.append('room_type', params.room_type.toString());
                        if (params === null || params === void 0 ? void 0 : params.search)
                            queryParams.append('search', params.search);
                        if (params === null || params === void 0 ? void 0 : params.page)
                            queryParams.append('page', params.page.toString());
                        if (params === null || params === void 0 ? void 0 : params.limit)
                            queryParams.append('page_size', params.limit.toString());
                        return [4 /*yield*/, apiService.get("/api/v1/channel_manager/rate_plans/?".concat(queryParams))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    // === AVAILABILITY ===
    InventoryService.prototype.getAvailability = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParams, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParams = new URLSearchParams();
                        if (params === null || params === void 0 ? void 0 : params.room_type)
                            queryParams.append('room_type', params.room_type.toString());
                        if (params === null || params === void 0 ? void 0 : params.date)
                            queryParams.append('date', params.date);
                        if (params === null || params === void 0 ? void 0 : params.date_from)
                            queryParams.append('date__gte', params.date_from);
                        if (params === null || params === void 0 ? void 0 : params.date_to)
                            queryParams.append('date__lte', params.date_to);
                        if (params === null || params === void 0 ? void 0 : params.page)
                            queryParams.append('page', params.page.toString());
                        if (params === null || params === void 0 ? void 0 : params.limit)
                            queryParams.append('page_size', params.limit.toString());
                        return [4 /*yield*/, apiService.get("/api/v1/channel_manager/availability/?".concat(queryParams))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    InventoryService.prototype.createAvailability = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiService.post('/api/v1/channel_manager/availability/', data)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    InventoryService.prototype.updateAvailability = function (id, data) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiService.patch("/api/v1/channel_manager/availability/".concat(id, "/"), data)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    InventoryService.prototype.deleteAvailability = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiService.delete("/api/v1/channel_manager/availability/".concat(id, "/"))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    InventoryService.prototype.bulkUpdateAvailability = function (updates) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiService.put('/api/v1/channel_manager/availability/bulk-update/', {
                            values: updates
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    InventoryService.prototype.syncAvailabilityFromChannex = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiService.post('/api/v1/channel_manager/availability/sync-from-channex/', data)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    InventoryService.prototype.syncAvailabilityToChannex = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiService.post('/api/v1/channel_manager/availability/sync-to-channex/', data)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    // === RESTRICTIONS ===
    InventoryService.prototype.getRestrictions = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParams, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParams = new URLSearchParams();
                        if (params === null || params === void 0 ? void 0 : params.rate_plan)
                            queryParams.append('rate_plan', params.rate_plan.toString());
                        if (params === null || params === void 0 ? void 0 : params.restriction_type)
                            queryParams.append('restriction_type', params.restriction_type);
                        if (params === null || params === void 0 ? void 0 : params.date)
                            queryParams.append('date', params.date);
                        if (params === null || params === void 0 ? void 0 : params.date_from)
                            queryParams.append('date__gte', params.date_from);
                        if (params === null || params === void 0 ? void 0 : params.date_to)
                            queryParams.append('date__lte', params.date_to);
                        if (params === null || params === void 0 ? void 0 : params.page)
                            queryParams.append('page', params.page.toString());
                        if (params === null || params === void 0 ? void 0 : params.limit)
                            queryParams.append('page_size', params.limit.toString());
                        return [4 /*yield*/, apiService.get("/api/v1/channel_manager/restrictions/?".concat(queryParams))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    InventoryService.prototype.createRestriction = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiService.post('/api/v1/channel_manager/restrictions/', data)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    InventoryService.prototype.updateRestriction = function (id, data) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiService.patch("/api/v1/channel_manager/restrictions/".concat(id, "/"), data)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    InventoryService.prototype.deleteRestriction = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiService.delete("/api/v1/channel_manager/restrictions/".concat(id, "/"))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    InventoryService.prototype.bulkUpdateRestrictions = function (updates) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiService.put('/api/v1/channel_manager/restrictions/bulk-update/', {
                            values: updates
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    return InventoryService;
}());
// Singleton instance
export var inventoryService = new InventoryService();
// Query keys for React Query
export var INVENTORY_QUERY_KEYS = {
    roomTypes: 'room-types',
    ratePlans: 'rate-plans',
    availability: 'availability',
    restrictions: 'restrictions',
    roomTypesForProperty: function (propertyId) { return ['room-types', 'property', propertyId]; },
    ratePlansForRoomType: function (roomTypeId) { return ['rate-plans', 'room-type', roomTypeId]; },
    availabilityForRoomType: function (roomTypeId, dateFrom, dateTo) {
        return ['availability', 'room-type', roomTypeId, dateFrom, dateTo];
    },
    restrictionsForRatePlan: function (ratePlanId, dateFrom, dateTo) {
        return ['restrictions', 'rate-plan', ratePlanId, dateFrom, dateTo];
    },
};
// Helpers for React Query
export var inventoryQueries = {
    roomTypes: function (params) { return ({
        queryKey: [INVENTORY_QUERY_KEYS.roomTypes, params],
        queryFn: function () { return inventoryService.getRoomTypes(params); },
        staleTime: 1000 * 60 * 5, // 5 minutes
    }); },
    ratePlans: function (params) { return ({
        queryKey: [INVENTORY_QUERY_KEYS.ratePlans, params],
        queryFn: function () { return inventoryService.getRatePlans(params); },
        staleTime: 1000 * 60 * 5, // 5 minutes
    }); },
    availability: function (params) { return ({
        queryKey: [INVENTORY_QUERY_KEYS.availability, params],
        queryFn: function () { return inventoryService.getAvailability(params); },
        staleTime: 1000 * 60 * 2, // 2 minutes
    }); },
    restrictions: function (params) { return ({
        queryKey: [INVENTORY_QUERY_KEYS.restrictions, params],
        queryFn: function () { return inventoryService.getRestrictions(params); },
        staleTime: 1000 * 60 * 2, // 2 minutes
    }); },
};
